import { HTMLAttributes, ReactNode } from 'react';

import { Container, Description, Texts, Title } from './Topic.styles';

interface ITopic extends HTMLAttributes<HTMLInputElement> {
  Icon: ReactNode;
  title: string;
  description: string;
  comingSoon?: boolean;
  active?: boolean;
}

const Topic = ({
  Icon,
  title,
  description,
  comingSoon,
  onClick,
  active,
}: ITopic) => {
  return (
    <Container onClick={onClick} disabled={comingSoon} active={active}>
      {Icon}

      <div style={{ width: 16 }} />
      <Texts>
        <Title active={active}>{title}</Title>

        <div style={{ height: 4 }} />
        <Description active={active}>{description}</Description>
      </Texts>
    </Container>
  );
};

export { Topic };
